<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {}
  },
}
</script>

<template>
  <div class="Endocrinology">
    <div class="Endocrinology__banner">
      <div class="Endocrinology__wrapper container">
        <div class="left">
          <h1 class="Endocrinology__banner--title">Ендокринологія</h1>
        </div>
        <div class="right">
          <img class="img-desc" src="@/assets/img/Endocrinology/main.svg" alt="banner">
          <img class="img-mob" src="@/assets/img/Endocrinology/main-mob.svg" alt="banner">
        </div>
      </div>
    </div>

    <section class="section section2">

      <div class="container">
        <div class="section2__col">
          <h1>Програма «ТерапіяПЛЮС»</h1>
          <p>Дія програми підтримки пацієнтів
            «ТерапіяПЛЮС» поширюється на оригінальні* цукрознижувальні препарати
            компанії «АстраЗенека» для лікування
            цукрового діабету 2&#8288;-&#8288;го&nbsp;типу.</p>
        </div>
        <div class="section2__img">
          <img src="@/assets/img/Endocrinology/section2_img.svg" alt="tabs">
        </div>
      </div>
    </section>

    <div class="fullImg">
      <img src="@/assets/img/Endocrinology/section2_img.svg" alt="tabs">
    </div>


    <section class="section section3">
      <div class="container">
        <div class="section3__col section3__col--left">
          <h1>Цукровий діабет</h1>
          <p>Це хронічне захворювання, що проявляється стійким підвищенням рівня глюкози в крові. Причиною цього є
            абсолютна або відносна недостатність інсуліну — гормону, що знижує рівень глюкози в крові та спричиняє
            її проникнення до клітин організму, де глюкоза перетворюється на енергію.</p>

          <div class="section3__img">
            <img src="@/assets/img/Endocrinology/section3_img.svg" alt="tabs">
          </div>
        </div>

        <div class="section3__col section3__col--right">
          <p class="section3__text">Хоча цукровий діабет (ЦД) 1-го типу залишається найпоширенішою формою
            діабету в молодих осіб у багатьох групах населення, особливо тих, які мають
            європейське походження, ЦД 2-го типу стає все більш важливою проблемою
            системи охорони здоров’я в усьому світі серед дітей окремих етнічних груп із
            високим ризиком його розвитку, а також серед хворих з ожирінням тяжкого
            ступеня. При ЦД 2-го типу з початком у молодому віці швидше розвиваються ускладнення та серцево-судинний
            ризик, ніж при ЦД 1-го типу з початком у
            молодому віці або ЦД 2-го типу в дорослих, що призводить до вищих показників
            захворюваності та смертності.</p>
          <p class="section3__smallText"><span>*Оригінальний (інноваційний) лікарський засіб</span>&nbsp;— <i>лікарський
            засіб, що був уперше
            у світі зареєстрований на основі повного комплекту документів щодо його якості, безпеки та ефективності
            (повної реєстраційної інформації). (визначення з наказу Міністерства охорони здоров’я України № 426 від
            26.08.2005
            (зі змінами) у чинній редакції станом на квітень 2023 року).</i></p>

        </div>
      </div>
    </section>

    <section class="section section6">
      <div class="section6__row section6__row--first">
        <div class="container">
          <div class="section6__wrapper">
            <div class="section6__col">
              <p><span>Цукровий діабет — захворювання, яке потребує зміни
              способу життя, а також постійного спостереження
              та лабораторного контролю.</span><br>Відсутність регулярного відвідування лікаря, виконання фізичних вправ
                і прийому препаратів може
                призвести до розвитку ускладнень діабету (серцева недостатність, інфаркт, інсульт, захворювання
                нирок, діабетична стопа, діабетичне ураження очей) у майбутньому.</p>
              <p>Метою лікування є
                компенсація <span>цукрового
                діабету</span>, тобто досягнення цільових показників глікемії, а
                також запобігання розвитку
                діабетичних ускладнень
                (наприклад, серцево-судинних захворювань), які
                загрожують передчасним
                порушенням працездатності
                та погіршенням якості життя.</p>
            </div>
            <div class="section6__img">
              <img src="@/assets/img/Endocrinology/section4_img.svg" alt="img">
            </div>
          </div>
          <h2>Учасник програми, якому лікар призначив відповідний лікарський засіб**, може придбати його зі знижкою,
            користуючись карткою учасника програми</h2>
        </div>
      </div>
      <div class="section6__row section6__row--second ">
        <div class="container">
          <div class="section6__table section6__table--desk">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
                <td class="section6__item-head">Дозування</td>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--first">
              <span>
                Саксагліптин
                </span>
                </td>
                <td class="section6__item-body">
                  <span>5 мг</span>
                </td>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">20<span> % </span></span>
              </span></td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--first">
              <span>
              Саксагліптин<br>
              <span>+</span><br>
              Метформін
                </span>
                </td>
                <td class="section6__item-body">
              <span>
              5 мг/1000 мг
              </span></td>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">20<span> % </span></span>
              </span></td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--first">
              <span>
              Дапагліфлозин<br>
              <span>+</span><br>
              Метформін
                </span>
                </td>
                <td class="section6__item-body">
              <span>
              5 мг/1000 мг<br><span class="top">+</span><br>10 мг/1000 мг
              </span></td>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">20<span> % </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <div class="section6__table section6__table--mob">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
              Саксагліптин
                </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head">Дозування</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
                5 мг
              </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">20<span> % </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <div class="section6__table section6__table--mob">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
              Саксагліптин<br>
              <span>+</span><br>
              Метформін
                </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head">Дозування</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
        5 мг/1000 мг
              </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">20<span> % </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <div class="section6__table section6__table--mob">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
              Дапагліфлозин<br>
              <span>+</span><br>
              Метформін
                </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head">Дозування</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
        5 мг/1000 мг<br><span class="top">+</span><br>10 мг/1000 мг
              </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">20<span> % </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <p class="section6__smallText">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4.44444 0H3.55556V2.92615L1.48584 0.856435L0.857303 1.48497L2.92788 3.55556H0V4.44444H2.92668L0.857066 6.51405L1.48561 7.14259L3.55556 5.07264V8H4.44444V5.07212L6.51416 7.14183L7.1427 6.51329L5.07385 4.44444H8V3.55556H5.07264L7.14246 1.48574L6.51392 0.857201L4.44444 2.92668V0Z"
                    fill="white"/>
            </svg>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4.44444 0H3.55556V2.92615L1.48584 0.856435L0.857303 1.48497L2.92788 3.55556H0V4.44444H2.92668L0.857066 6.51405L1.48561 7.14259L3.55556 5.07264V8H4.44444V5.07212L6.51416 7.14183L7.1427 6.51329L5.07385 4.44444H8V3.55556H5.07264L7.14246 1.48574L6.51392 0.857201L4.44444 2.92668V0Z"
                    fill="white"/>
            </svg>
            <span>Інформацію щодо лікарських засобів, які беруть участь у програмі «ТерапіяПЛЮС», ви можете знайти на сайті
              <a
                  href="https://www.terapiaplus.com/" target="_blank">www.terapiaplus.com.</a><br>
              Умови програми, зокрема розмір знижок, можуть бути змінені без попередження учасників програми.<br>
              Не змінюйте курс терапії самостійно. Не пропускайте прийом призначених вам препаратів!
            </span>
          </p>
        </div>
      </div>
    </section>

    <section class="section section7">
      <div class="content container">
        <a href="/TerapiaPLUS_patient_pakage_210x148_2025-03___Endo___001.pdf" download
           class="section7__download">
          <p>Завантажити матеріали</p>
        </a>
      </div>

    </section>
  </div>
</template>

<style scoped lang="scss">
.Endocrinology {

  &__banner {
    overflow: hidden;
    position: relative;
    height: 396px;
    // padding: 88px 0 308px;
    background: #69b6c7 url("~@/assets/img/pulmonology/patternt.png") no-repeat center calc(100% - 131px);
    background-size: contain;
    background-position-y: bottom;
    z-index: 1;

    @media (max-width: 1200px) {
      height: 260px;
    }

    @media (max-width: 768px) {
      //background: #69b6c7;
      background: #69b6c7 url("~@/assets/img/MyocardialInfarction/pattern-mob.png") no-repeat right bottom;
      background-size: 93%;

      height: auto;
    }

    &--title {
      font-size: 72px;
      line-height: 80px;
      font-weight: 700;
      color: #fff;
      margin-top: 115px;
      @media (max-width: 1200px) {
        font-size: 56px;
        line-height: 64px;
        margin-top: 40px;
      }
      @media screen and (max-width: 1336px) {
      }
      @media screen and (max-width: 1024px) {

      }
      @media (max-width: 768px) {
        font-size: 48px;
        line-height: 40px;
        padding-left: 20px;
      }
      @media (max-width: 550px) {
        font-size: 32px;

      }

    }
  }

  &__wrapper {
    display: flex;
    justify-content: space-between;
    height: 100%;
    position: relative;
    //padding-left: 0;
    //padding-right: 0;

    @media (max-width: 1024px) {
      flex-direction: column;
    }
    @media (max-width: 768px) {
      padding-left: 0;
      padding-right: 0;
    }
    @media (max-width: 400px) {
      padding: 0;
    }

    .right {
      position: absolute;
      right: 10%;
      bottom: 0;
      top: 0;
      display: flex;
      justify-content: flex-end;

      @media screen and (max-width: 1770px) {
        right: 5%;
      }
      @media screen and (max-width: 991px) {
        right: -5%;
      }

      @media (max-width: 768px) {
        position: relative;
      }

      .img-desc {
        width: auto;
        height: 100%;
        position: relative;

        @media (max-width: 1200px) {
          //width: 100%;
          //height: auto;
        }
        @media (max-width: 768px) {
          display: none;
        }
      }

      .img-mob {
        display: none;
        width: 100%;
        height: auto;
        margin-top: -10%;
        @media (max-width: 768px) {
          display: block;
        }
      }
    }
  }

  .section2 {
    width: 100%;
    margin: 0 auto;
    background: white;
    position: relative;

    @media screen and (max-width: 991px) {
      background: white;
    }

    .container {
      padding-top: 152px;
      padding-bottom: 152px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      z-index: 1;


      @media screen and (max-width: 1440px) {

        padding-top: 100px;
        padding-bottom: 100px;
      }

      @media screen and (max-width: 1200px) {
        padding-top: 80px;
        padding-bottom: 80px;

      }

      @media screen and (max-width: 991px) {
        flex-direction: column;
        padding-top: 48px;
        padding-bottom: 48px;
      }
    }

    &__col {
      max-width: 680px;
      width: 100%;
      margin-top: 15px;
      min-width: 500px;

      @media screen and (max-width: 1440px) {
        max-width: 545px;
      }

      @media screen and (max-width: 1200px) {
        min-width: 1px;
        max-width: 445px;
      }

      @media screen and (max-width: 991px) {
        max-width: 100%;
      }

      h1 {
        color: var(--Purple, #3C1053);

        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        margin-bottom: 21px;
        @media screen and (max-width: 1200px) {
          font-size: 32px;
          line-height: 40px;
          margin-bottom: 20px;
        }
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
        margin-bottom: 24px;

        @media screen and (max-width: 1200px) {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 18px;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &__img {
      position: absolute;
      right: 0;
      bottom: -30%;
      max-width: 1008px;
      width: 100%;

      @media screen and (max-width: 1770px) {
        max-width: 900px;
      }

      @media screen and (max-width: 1440px) {
        max-width: 700px;
      }

      @media screen and (max-width: 1200px) {
        max-width: 650px;
      }

      @media screen and (max-width: 991px) {
        display: none;
      }

      img {
        min-width: 1px;
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  .section3 {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;

    background: url("~@/assets/img/Endocrinology/section3_pattern.svg") #F0F8FA no-repeat center bottom;
    background-size: 100% 100%;

    .container {
      padding-top: 152px;
      padding-bottom: 152px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 1;


      @media screen and (max-width: 1440px) {
        padding-top: 100px;
        padding-bottom: 100px;
      }

      @media screen and (max-width: 1200px) {
        padding-top: 80px;
        padding-bottom: 80px;

      }

      @media screen and (max-width: 991px) {
        background: #F0F8FA;
        flex-direction: column;
        padding-top: 103px;
        padding-bottom: 48px;
      }
    }

    &__col {
      max-width: 681px;
      width: 100%;

      @media screen and (max-width: 1200px) {
        min-width: 1px;
        max-width: 500px;
      }

      @media screen and (max-width: 991px) {
        max-width: 100%;
        margin-left: 0;
      }

      &--left {
        margin-right: 25px;


        @media screen and (max-width: 991px) {
          margin-right: 0;
        }

        h1 {
          color: var(--Purple, #3C1053);
          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          margin-bottom: 21px;
          @media screen and (max-width: 1200px) {
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 20px;
          }
        }

        p {
          color: var(--Purple, #3C1053);
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px;
          margin-bottom: 143px;

          @media screen and (max-width: 1200px) {
            font-size: 18px;
            line-height: 28px;
          }

          @media screen and (max-width: 991px) {
            margin-bottom: 20px;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      &--right {
        margin-top: 292px;
        margin-left: 25px;
        @media screen and (max-width: 991px) {
          margin-left: 0;
          margin-top: 20px;
        }
      }
    }

    &__img {
      display: flex;
      justify-content: center;
      max-width: 568px;
      width: 100%;

      @media screen and (max-width: 1200px) {
      }

      @media screen and (max-width: 991px) {
        max-width: 70%;
        margin: 0 auto;
      }
      @media screen and (max-width: 600px) {
        max-width: 80%;
        margin: 0 auto;
      }

      @media screen and (max-width: 425px) {
        max-width: 100%;
        margin: 0 auto;
      }


      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    &__text {
      color: var(--Purple, #3C1053);
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px;
      margin-bottom: 161px;

      @media screen and (max-width: 1200px) {
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 120px;
      }

      @media screen and (max-width: 991px) {
        margin-bottom: 24px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__smallText {
      margin-left: 64px;
      color: var(--Purple, #3C1053);
      line-height: 24px;
      font-size: 16px;

      @media screen and (max-width: 1200px) {
        margin-left: 32px;
      }

      @media screen and (max-width: 991px) {
        margin-left: 0;
      }

      span {
        font-style: normal;
        font-weight: 600;
      }

      i {
        font-style: italic;
        font-weight: 400;
      }
    }
  }

  .section6 {

    &__row {

      &--first {
        padding: 150px 0 220px 0;

        background: #FFEEC3;
        background-size: contain;


        @media screen and (max-width: 1024px) {
          margin-right: 0;
          padding: 48px 20px 100px 20px;

          background-size: cover;
        }

        .container {
          padding-left: 0;
          padding-right: 0;
        }

        h2 {
          color: var(--Purple, #3C1053);
          text-align: center;
          width: 80%;
          margin: 0 auto;

          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          @media (max-width: 1440px) {
            width: 100%;
            font-size: 42px;
            line-height: 52px;
          }

          @media screen and (max-width: 1024px) {
            font-size: 32px;
            width: 100%;
            line-height: 40px; /* 125% */
            text-align: left;
          }
        }
      }

      &--second {
        background: #69B6C7;
        padding: 0 0 150px 0;


        @media screen and (max-width: 1024px) {
          padding: 0 20px 48px 20px;
        }

        .container {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }

    &__table {

      width: 100%;
      margin: 0 auto 0 auto;
      top: -120px;
      position: relative;

      @media screen and (max-width: 1024px) {
        top: -60px;
      }

      &--mob {
        display: none;
        @media screen and (max-width: 1024px) {
          display: block;
        }
      }

      &--desk {
        @media screen and (max-width: 1024px) {
          display: none;
        }
      }

      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        border: 1px dashed #FFF;

        @media screen and (max-width: 1024px) {
          margin-bottom: 12px;
        }

        td {
          width: calc(100% / 3);
          @media screen and (max-width: 1024px) {
            width: 100%;

          }
        }
      }
    }

    &__item {
      //height: fit-content;

      &-head {
        color: #FFF;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;

        //border-top: 1px dashed #FFF;
        border-left: 1px dashed #FFF;
        background: #69B6C7;
        margin-bottom: 0;
        padding: 32px 20px;
        text-align: center;

        &--first {
          border-left: none;
        }

        @media screen and (max-width: 1024px) {
          line-height: 16px;
          font-size: 16px;

          padding: 10px 20px;
          //border-top: 1px dashed #FFF;
          //border-left: 1px dashed #FFF;
          //border-right: 1px dashed #FFF;
        }

        &--last {
          //border-right: 1px dashed #FFF;
        }
      }

      &-body {
        border-top: 1px dashed #69B6C7;
        border-left: 1px dashed #69B6C7;
        //border-bottom: 1px dashed #69B6C7;
        background: var(--White, #FFF);

        padding: 52px 20px;
        height: 100%;
        text-align: center;

        @media screen and (max-width: 1024px) {
          border-left: none;
          padding: 32px 20px;
        }

        > span {
          color: var(--Purple, #3C1053);
          font-size: 34px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 105.882% */

          .mt {
            color: var(--Purple, #3C1053);
            font-size: 34px;
            font-style: normal;
            font-weight: 400;
            line-height: 36px;

            display: inline-block;

            padding-top: 20px;

            @media screen and (max-width: 1024px) {
              font-size: 24px;
              line-height: 36px;
            }
          }

          span {
            color: #69B6C7;
            font-size: 44px;
            font-style: normal;
            font-weight: 400;
            line-height: 36px; /* 81.818% */

            &.top {
              position: relative;
              top: 4px;
              //@media screen and (max-width: 1024px) {
              //  top: 10px;
              //}
            }

            @media screen and (max-width: 1024px) {
              font-size: 44px;
              line-height: 36px;
            }

            &.big {
              color: #69B6C7;
              font-size: 58px;
              font-style: normal;
              font-weight: 700;
              line-height: 64px; /* 110.345% */

              @media screen and (max-width: 1024px) {
                font-size: 58px;
                line-height: 64px;
              }

              span {
                font-size: 42px;
                line-height: 40px; /* 95.238% */
                font-weight: 700;
              }
            }
          }

          @media screen and (max-width: 1024px) {
            font-size: 24px;
            line-height: 36px;
          }
        }

        &--last {
          //border-right: 1px dashed #69B6C7;
        }

        &--first {
          border-left: none;
        }
      }

    }

    &__smallText {
      max-width: 1680px;
      width: 100%;
      margin: -80px auto 0 auto;

      color: #FFF;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;

      display: flex;
      align-items: flex-start;

      @media screen and (max-width: 1024px) {
        margin: -40px auto 0 auto;
        font-size: 14px;
        line-height: 16px;
      }

      svg {
        min-width: 8px;
        height: auto;
        display: inline-block;
        position: relative;
        top: 6px;
        margin-right: 8px;

        @media screen and (max-width: 1024px) {
          top: 4px;
        }

        &:first-child {
          margin-right: 0;
        }
      }

      a {
        color: #FFF;
        font-size: 16px;
        font-weight: 700;
        text-decoration-line: underline;
        @media screen and (max-width: 1024px) {
          font-size: 14px;
        }
      }
    }

    &__wrapper {
      display: flex;
      justify-content: space-between;
      margin-bottom: 122px;

      @media screen and (max-width: 991px) {
        flex-direction: column;
        margin-bottom: 48px;
      }
    }

    &__col {
      max-width: 681px;
      width: 100%;
      margin-right: 25px;
      @media screen and (max-width: 991px) {
        margin-right: 0;
        margin-bottom: 20px;
        max-width: 100%;
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }

        span {
          font-weight: 700;
        }

        @media screen and (max-width: 1200px) {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 20px;
        }
      }
    }

    &__img {
      max-width: 724px;
      width: 100%;
      margin-left: 25px;

      @media screen and (max-width: 991px) {
        max-width: 70%;
        margin: 0 auto;
      }

      @media screen and (max-width: 600px) {
        max-width: 80%;
      }

      @media screen and (max-width: 425px) {
        max-width: 100%;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  .section7 {

    background: rgba(105, 182, 199, 0.1);


    .content {

      padding: 100px 0;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      @media screen and (max-width: 1024px) {
        padding: 60px 20px 48px 20px;
      }

    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;

      text-decoration: none;
      border-radius: 2px;
      border: 1px solid var(--Purple, #3C1053);
      background: #70C2D4;
      padding: 24px 44px;
      @media screen and (min-width: 1024px) {
        &:hover {
          background: #C4D600;
        }
      }

      &:active {
        background: #C4D600;
      }

      @media screen and (max-width: 1024px) {
      }
      @media screen and (max-width: 425px) {
        padding: 24px;
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 1.26px;
        text-transform: uppercase;
        @media screen and (max-width: 1024px) {
          font-size: 14px;
          letter-spacing: 0.98px;
        }
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
      pointer-events: none;
      z-index: 10;
    }

    &__videoWrapper {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      width: 100%;
      height: 0;
      overflow: hidden;


      iframe {
        position: absolute;
        z-index: 20;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  .fullImg {
    position: relative;
    z-index: 3;
    display: none;
    width: 80%;
    margin-left: auto;
    margin-right: 0;
    margin-bottom: -13%;
    @media screen and (max-width: 991px) {
      display: block;
      width: 75%;
      margin-bottom: -10%;
    }
    @media screen and (max-width: 600px) {
      width: 95%;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }
}
</style>